import { render } from "./TextMessage.vue?vue&type=template&id=d2172e32&scoped=true"
import script from "./TextMessage.vue?vue&type=script&lang=js"
export * from "./TextMessage.vue?vue&type=script&lang=js"

import "./TextMessage.vue?vue&type=style&index=0&id=d2172e32&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2172e32"]])

export default __exports__